// import React, { useRef } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import product1 from '../assets/images/fire.jpeg';
// import product2 from '../assets/images/water.jpeg';
// import product3 from '../assets/images/molu_water.jpeg';


// const EmailCapture = () => {
//   // Ref for smooth scrolling to the products section
//   const productsRef = useRef(null);

//   // Scroll to products section
//   const handleShopNowClick = (e) => {
//     e.preventDefault();
//     productsRef.current.scrollIntoView({ behavior: "smooth" });
//   };

//   // Handle Add to Cart functionality
//   const handleAddToCart = (productName) => {
//     alert(`${productName} added to cart!`);
//   };

//   return (
//     <div>
//       {/* Header */}
//       <header className="bg-dark text-white">
//         <nav className="navbar navbar-expand-lg navbar-dark container">
//           <a className="navbar-brand" href="#">
//             Molu
//           </a>
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto">
//               <li className="nav-item">
//                 <a className="nav-link" href="#">
//                   Shop
//                 </a>
//               </li>
//               <li className="nav-item">
//                 <a className="nav-link" href="#">
//                   Learn
//                 </a>
//               </li>
//               <li className="nav-item">
//                 <a className="nav-link" href="#">
//                   Blog
//                 </a>
//               </li>
//               <li className="nav-item">
//                 <a className="nav-link" href="#">
//                   Contact
//                 </a>
//               </li>
//             </ul>
//             <div className="ms-3">
//               <a href="#" className="text-white me-3">
//                 🔍
//               </a>
//               <a href="#" className="text-white">
//                 🛒
//               </a>
//             </div>
//           </div>
//         </nav>
//       </header>

//       {/* Main Content */}
//       <main>
//         {/* Hero Section */}
//         <section
//           className="hero d-flex align-items-center text-center bg-dark text-white"
//           style={{ height: "400px" }}
//         >
//           <div className="container">
//             <h1>Men's Skincare & Grooming</h1>
//             <p className="lead">Discover the best all-natural men's products.</p>
//             <a
//               href="#"
//               className="btn btn-light cta-button"
//               onClick={handleShopNowClick}
//             >
//               Shop Now
//             </a>
//           </div>
//         </section>

//         {/* Products Section */}
//         <section className="products py-5" ref={productsRef}>
//           <div className="container">
//             <h2 className="text-center mb-4">Featured Products</h2>
//             <div className="row">
//               {/* Product Cards */}
//               {[
//                 {
//                   id: 1,
//                   name: "Face Moisturizer",
//                   price: "$35.00",
//                   img: product1,
//                 },
//                 {
//                   id: 2,
//                   name: "Shaving Cream",
//                   price: "$25.00",
//                   img: product2,
//                 },
//                 {
//                   id: 3,
//                   name: "Body Wash",
//                   price: "$20.00",
//                   img: product3,
//                 },
//               ].map((product) => (
//                 <div className="col-md-4" key={product.id}>
//                   <div className="card product-card">
//                     <img
//                       src={product.img}
//                       className="card-img-top"
//                       alt={product.name}
//                     />
//                     <div className="card-body text-center">
//                       <h5 className="card-title">{product.name}</h5>
//                       <p className="card-text">{product.price}</p>
//                       <button
//                         className="btn btn-primary"
//                         onClick={() => handleAddToCart(product.name)}
//                       >
//                         Add to Cart
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* Footer */}
//       <footer className="bg-dark text-white text-center py-3">
//         <p>&copy; 2024 Molu Men's Products. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// };

// export default EmailCapture;


// import React from "react";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import "bootstrap/dist/css/bootstrap.min.css";
// import product1 from '../assets/images/fire.jpeg';

// const EmailCapture = () => {
//   // Validation schema using Yup
//   const validationSchema = Yup.object({
//     firstName: Yup.string().required("First name is required"),
//     lastName: Yup.string().required("Last name is required"),
//     email: Yup.string().email("Invalid email address").required("Email is required"),
//   });

//   // Submit handler
//   const handleSubmit = (values, { resetForm }) => {
//     alert(`Thank you, ${values.firstName}! You'll be notified when Fire Formula is available.`);
//     resetForm();
//   };

//   return (
//     <div>
//       <header className="bg-dark text-white text-center py-3">
//         <h1>Fire Formula Launch</h1>
//         <p>Be the first to know when Fire Formula is available!</p>
//       </header>

//       <main className="container py-5">
//         {/* Hero Section */}
//         <section className="text-center mb-5">
//           <img
//             src={product1}
//             alt="Fire Formula"
//             className="img-fluid rounded"
//             style={{ maxWidth: "400px" }}
//           />
//           <h2 className="mt-3">Fire Formula</h2>
//           <p className="lead">
//             Ignite your potential with Fire Formula—crafted for peak performance and ultimate results.
//             Sign up below to be notified as soon as it's available!
//           </p>
//         </section>

//         {/* Signup Form Section */}
//         <section className="signup-form">
//           <h3 className="text-center mb-4">Notify Me</h3>
//           <Formik
//             initialValues={{
//               firstName: "",
//               lastName: "",
//               email: "",
//             }}
//             validationSchema={validationSchema}
//             onSubmit={handleSubmit}
//           >
//             {() => (
//               <Form className="mx-auto" style={{ maxWidth: "500px" }}>
//                 <div className="mb-3">
//                   <label htmlFor="firstName" className="form-label">
//                     First Name
//                   </label>
//                   <Field
//                     type="text"
//                     id="firstName"
//                     name="firstName"
//                     className="form-control"
//                   />
//                   <ErrorMessage
//                     name="firstName"
//                     component="div"
//                     className="text-danger"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="lastName" className="form-label">
//                     Last Name
//                   </label>
//                   <Field
//                     type="text"
//                     id="lastName"
//                     name="lastName"
//                     className="form-control"
//                   />
//                   <ErrorMessage
//                     name="lastName"
//                     component="div"
//                     className="text-danger"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label htmlFor="email" className="form-label">
//                     Email
//                   </label>
//                   <Field
//                     type="email"
//                     id="email"
//                     name="email"
//                     className="form-control"
//                   />
//                   <ErrorMessage
//                     name="email"
//                     component="div"
//                     className="text-danger"
//                   />
//                 </div>
//                 <button type="submit" className="btn btn-primary w-100">
//                   Notify Me
//                 </button>
//               </Form>
//             )}
//           </Formik>
//         </section>
//       </main>

//       <footer className="bg-dark text-white text-center py-3">
//         <p>&copy; 2024 Molu Men's Products. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// };

// export default EmailCapture;


import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import product1 from '../assets/images/fire.jpeg';

const EmailCapture = () => {
  // Validation schema using Yup
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
  });

  // Submit handler
  const handleSubmit = (values, { resetForm }) => {
    alert(`Thank you, ${values.firstName}! You'll be notified when Fire Formula is available.`);
    resetForm();
  };

  return (
    <div>
      {/* Header Section */}
      <header className="bg-dark text-white text-center py-3">
        <h1>Fire Formula Launch</h1>
        <p>Be the first to know when Fire Formula is available!</p>
      </header>

      {/* Full-Width Image Section */}
      <section>
        <img
          src={product1}
          alt="Fire Formula"
          className="img-fluid"
          style={{ width: "100%", height: "auto" }}
        />
      </section>

      <main className="container py-5">
        {/* Product Description */}
        <section className="text-center mb-5">
          <h2>Fire Formula</h2>
          <p className="lead">
            Ignite your potential with Fire Formula—crafted for peak performance and ultimate results.
            Sign up below to be notified as soon as it's available!
          </p>
        </section>

        {/* Signup Form Section */}
        <section className="signup-form">
          <h3 className="text-center mb-4">Notify Me</h3>
          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form className="mx-auto" style={{ maxWidth: "500px" }}>
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">
                    First Name
                  </label>
                  <Field
                    type="text"
                    id="firstName"
                    name="firstName"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="firstName"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <Field
                    type="text"
                    id="lastName"
                    name="lastName"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="lastName"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Notify Me
                </button>
              </Form>
            )}
          </Formik>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="bg-dark text-white text-center py-3">
        <p>&copy; 2024 Molu Men's Products. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default EmailCapture;
